import Loading from '../../../Common/Loading';
import { ServicesPerMonthPerYearTotal } from './ServicesPerMonthPerYearTotal';
import { ServicesPerYearTotal } from './ServicesPerYearTotal';

import { Total } from './Total';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

const Permanence = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Total />
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearTotal />
                <ServicesPerMonthPerYearTotal />
            </div>
        </>
    );
};

export default Permanence;
